// src/tenant.js

/**
 * resolveTenantId
 * ---------------------------------------
 * URL から tenantId を自動判定する
 *
 * 現在は suomin-prod.web.app を suomi にマッピング
 * 将来 SaaS 化時にここを置き換える
 */

// go.akuto.app のフラット型公開URL（ポータルが発行する /拠点slug）→ テナントID
const AKUTO_SLUG_TENANTS = {
  "suomi-matsue": "suomi",
  "suomi-izumo": "suomi",
};

function resolveTenantId() {
  if (typeof window === "undefined") {
    return "suomi";
  }

  const host = window.location.hostname;
  const path = window.location.pathname;

  // -------------------------------
  // 🔹 固定マッピング（今はこれでOK）
  // -------------------------------
  if (host.includes("suomin-prod")) {
    return "suomi";
  }

  if (host.includes("suomin-9ff5a")) {
    return "suomi";
  }

  // -------------------------------
  // 🔹 AKUTO公開URL（go.akuto.app/{拠点slug} のフラット型）
  //    サブドメインは常に "go" なので、パスの拠点slugをテナントIDへ変換する。
  //    ポータルが発行する公開URLと対応（suomi松江/出雲は同一テナント suomi）。
  // -------------------------------
  if (host === "go.akuto.app") {
    const slug = path.split("/").filter(Boolean)[0] || "";
    return AKUTO_SLUG_TENANTS[slug.toLowerCase()] || "suomi";
  }

  // -------------------------------
  // 🔹 将来用：サブドメイン方式
  // -------------------------------
  const hostParts = host.split(".");
  if (hostParts.length >= 3) {
    const sub = hostParts[0];
    if (sub !== "www") {
      return sub;
    }
  }

  // -------------------------------
  // 🔹 パス方式
  // -------------------------------
  const pathParts = path.split("/").filter(Boolean);
  if (pathParts.length > 0) {
    return pathParts[0];
  }

  // -------------------------------
  // fallback
  // -------------------------------
  return "suomi";
}

// -------------------------------------
// 公開API
// -------------------------------------

export const TENANT_ID = resolveTenantId();
export const getTenantId = () => TENANT_ID;

/**
 * いまのURLで、テナントを表しているパスの接頭辞を返す（例: "/suomi-matsue"）。無ければ ""。
 *
 * ⚠LINEログインの復帰先を作るのに要る。LIFF のエンドポイントは**全テナント共通で1本**
 *   （`https://go.akuto.app/auth/line`）なので、LINEから戻ってきたときにパスから拠点が消える。
 *   戻り先にこの接頭辞を付けておかないと、別テナントのお客様が suomi に落ちる。
 */
export function getTenantPathPrefix() {
  if (typeof window === "undefined") return "";
  if (window.location.hostname !== "go.akuto.app") return "";

  const slug = window.location.pathname.split("/").filter(Boolean)[0] || "";
  return AKUTO_SLUG_TENANTS[slug.toLowerCase()] ? `/${slug}` : "";
}

console.log("[tenantId]", TENANT_ID);